class RegexConstants {
    public static PASSWORD_HAS_NUMBER = new RegExp("[0-9]+");
    public static PASSWORD_HAS_UPPERCHAR = new RegExp("[A-Z]+");
    public static PASSWORD_HAS_SYMBOL = new RegExp("[!@#$%^&*()_+=\\[{\\]};:<>|./?,-]");
    public static CUSTOMURL_HAS_VALID_CHARACTERS = new RegExp("^[a-zA-Z0-9_-]+$");
    public static HAS_MINIMUM_8_CHARS = new RegExp(".{8,}");
    public static HAS_MINIMUM_3_ALPHANUMERIC_CHARS = new RegExp("(?:.*[a-zA-Z0-9]){3,}");
    public static HAS_MAXIMUM_30_CHARS = new RegExp("^.{3,30}$");
    public static DIGITS_ONLY = new RegExp("^\\d+$");
    
}

export { RegexConstants }
